module.exports = __webpack_public_path__ + "static/media/TeamCaptainLogo_30h.61dfcff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamCaptainLogo_30h.png
// module id = 287
// module chunks = 0